import React, { HTMLAttributes } from 'react';
import { DropzoneContainer } from './styles';
import Dropzone from 'react-dropzone';

export interface Props extends HTMLAttributes<HTMLTextAreaElement> {
  /** Função caso o arquivo seja válido */
  onDropAccepted?: (e?: any) => void;

  /** Função caso o arquivo seja inválido */
  onDropRejected?: (e?: any) => void;

  /** Cor do fundo do botão e do texto destacado */
  primaryColor?: string;
}

export const FileInput = ({ onDropAccepted, onDropRejected, primaryColor = '#3453FF' }: Props) => {
  return (
    <Dropzone
      accept="image/jpeg,image/png,application/pdf,image/jpg"
      onDropAccepted={onDropAccepted}
      onDropRejected={onDropRejected}
    >
      {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
        <DropzoneContainer
          {...getRootProps()}
          isDragActive={isDragActive}
          isDragReject={isDragReject}
          primaryColor={primaryColor}
        >
          <input {...getInputProps()} />
          <div style={{ marginRight: '24px' }}>
            <svg
              width="56"
              height="56"
              viewBox="0 0 56 56"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="28" cy="28" r="28" fill={primaryColor} />
              <path
                d="M29 27H35C35.6 27 36 27.4 36 28C36 28.6 35.6 29 35 29H29V35C29 35.6 28.6 36 28 36C27.4 36 27 35.6 27 35V29H21C20.4 29 20 28.6 20 28C20 27.4 20.4 27 21 27H27V21C27 20.4 27.4 20 28 20C28.6 20 29 20.4 29 21V27Z"
                fill="white"
              />
            </svg>
          </div>
          <div>
            <span>Clique para adicionar</span> um arquivo
          </div>
        </DropzoneContainer>
      )}
    </Dropzone>
  );
};
